export default __webpack_public_path__ + "static/media/subjects_box_vector.7782f183.svg";